import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface DeactivateKeyMappingState {
  isLoading: boolean
  error: string | null
  httpStatus: number | null
  data: any | null
}

const initialState: DeactivateKeyMappingState = {
  isLoading: false,
  error: null,
  httpStatus: null,
  data: null
}

const deactivateKeyMappingSlice = createSlice({
  name: 'deactivateKeyMapping',
  initialState,
  reducers: {
    deactivateKeyMappingLoading: (state) => {
      return {
        isLoading: true,
        error: null,
        httpStatus: null,
        data: null
      }
    },
    deactivateKeyMappingSuccess: (state, action: PayloadAction<{ data: any, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: null,
        httpStatus: action.payload.httpStatus,
        data: action.payload.data
      }
    },
    deactivateKeyMappingFailure: (state, action: PayloadAction<{ error: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: action.payload.error,
        httpStatus: action.payload.httpStatus,
        data: null
      }
    }
  }
})

export const {
  deactivateKeyMappingLoading,
  deactivateKeyMappingSuccess,
  deactivateKeyMappingFailure
} = deactivateKeyMappingSlice.actions

export default deactivateKeyMappingSlice.reducer
